import { Typography, Box } from '@material-ui/core'
import React, { useMemo } from 'react'
import { CellProps, Column } from 'react-table'
import { Table } from '~/components'
import { formatDate } from '~/utils/date'
import { formatCurrency } from '~/utils/format'

import { Installment } from '../../'

export type InstallmentsTableProps = {
  installments: Installment[],
  numberOfInstallments: number,
  boldIndex?: number,
  noBorder?: boolean
}

export const InstallmentsTable: React.FC<InstallmentsTableProps> = (props) => {
  const { noBorder, installments, numberOfInstallments, boldIndex } = props
  const COLUMNS: Column<Installment>[] = useMemo(() => {
    return [
      {
        Header: () => {
          return (
            <Typography variant='airbnbBody1' sx={{ color: 'textGray2.main', fontWeight: '500' }}>
              Parcela
            </Typography>
          )
        },
        accessor: 'Parcela',
        Cell: ({ row: { original, index } }: CellProps<Installment>) => {
          const { installmentNumber } = original

          return (
            <Typography variant='airbnbBody1' sx={{
              color: 'textBlack.main',
              fontWeight: index === boldIndex ? '700' : '400'
            }}>
              {('0' + installmentNumber).slice(-2) + ` de ${('0' + numberOfInstallments).slice(-2)}`}
            </Typography>
          )
        }
      },
      {
        Header: () => {
          return (
            <Typography variant='airbnbBody1' sx={{ color: 'textGray2.main', fontWeight: '500' }}>
              Vencimento
            </Typography>
          )
        },
        accessor: 'Vencimento',
        Cell: ({ row: { original } }: CellProps<Installment>) => {
          const { dueDate } = original

          return (
            <Typography variant='airbnbBody1' sx={{
              color: 'textBlack.main'
            }}>
              {formatDate(dueDate)}
            </Typography>
          )
        }
      },
      {
        Header: () => {
          return (
            <Typography variant='airbnbBody1' sx={{ color: 'textGray2.main', fontWeight: '500' }}>
              Valor
            </Typography>
          )
        },
        accessor: 'Valor',
        Cell: ({ row: { original } }: CellProps<Installment>) => {
          const { installmentValue } = original

          return (
            <Typography variant='airbnbBody1' sx={{
              color: 'textBlack.main'
            }}>
              {formatCurrency(`${installmentValue}`)}
            </Typography>
          )
        }
      }
    ].filter(item => !!item) as any
  }, [numberOfInstallments])

  return (
    <Box sx={{
      padding: 0,
      width: '100%',
      border: noBorder ? '' : '1px solid #EBEBEB'
    }}>
      <Table
        data={installments}
        columns={COLUMNS}
      />
    </Box>
  )
}
